import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@soroush/ui';
import { BookingBar } from '../components/BookingBar';
import { BrandLogo } from '../components/BrandLogo';
import { DestinationGrid } from '../components/DestinationGrid';
import { HomeShortcuts } from '../components/HomeShortcuts';
import { destinations } from '../lib/destinations';

export function HomePage() {
  const { t } = useTranslation();

  return (
    <>
      <section className="home-hero" aria-label={t('common.brand')}>
        <div className="home-hero__media" aria-hidden="true">
          <img
            src="/images/hero-home.jpg?v=13"
            alt=""
            width={1920}
            height={1080}
            fetchPriority="high"
          />
        </div>
        <div className="home-hero__veil" aria-hidden="true" />
        <div className="home-hero__glow" aria-hidden="true" />

        <div className="home-hero__content">
          <div className="home-hero__booking sa-animate-in sa-animate-in--delay-2">
            <BookingBar />
          </div>
        </div>
      </section>

      <HomeShortcuts />

      <section className="home-section home-section--destinations" aria-labelledby="destinations-title">
        <div className="sa-container">
          <div className="home-section__head">
            <div>
              <p className="home-section__eyebrow">{t('common.exploreDestinations')}</p>
              <h2 id="destinations-title" className="sa-headline" style={{ marginBottom: 0 }}>
                {t('common.destinationsTitle')}
              </h2>
              <p className="sa-text-muted home-section__lead">{t('common.destinationsLead')}</p>
            </div>
            <Link to="/search" className="home-section__action">
              <Button variant="ghost">{t('common.viewAll')}</Button>
            </Link>
          </div>

          <DestinationGrid items={destinations} />
        </div>
      </section>

      <footer className="home-footer">
        <div className="home-footer__inner">
          <div className="home-footer__top">
            <div className="home-footer__brand-block">
              <BrandLogo variant="wordmark" size="sm" to="/" />
              <p className="home-footer__about">{t('common.footerAboutLead')}</p>
            </div>

            <nav className="home-footer__nav" aria-label={t('common.footerTravel')}>
              <div className="home-footer__col">
                <h3 className="home-footer__heading">{t('common.footerTravel')}</h3>
                <ul className="home-footer__links">
                  <li>
                    <Link to="/search">{t('nav.items.buyTicket')}</Link>
                  </li>
                  <li>
                    <Link to="/manage?mode=checkin">{t('nav.items.checkin')}</Link>
                  </li>
                  <li>
                    <Link to="/destinations/domestic">{t('nav.groups.destinations')}</Link>
                  </li>
                </ul>
              </div>

              <div className="home-footer__col">
                <h3 className="home-footer__heading">{t('common.footerAccount')}</h3>
                <ul className="home-footer__links">
                  <li>
                    <Link to="/login">{t('nav.login')}</Link>
                  </li>
                  <li>
                    <Link to="/miles">{t('nav.items.club')}</Link>
                  </li>
                  <li>
                    <Link to="/manage">{t('common.retrieveBooking')}</Link>
                  </li>
                </ul>
              </div>

              <div className="home-footer__col">
                <h3 className="home-footer__heading">{t('common.footerSupport')}</h3>
                <ul className="home-footer__links">
                  <li>
                    <Link to="/guide/buy">{t('common.footerHelpCenter')}</Link>
                  </li>
                  <li>
                    <Link to="/guide/baggage">{t('common.footerBaggage')}</Link>
                  </li>
                  <li>
                    <a href="#terms">{t('common.footerTerms')}</a>
                  </li>
                  <li>
                    <a href="#privacy">{t('common.footerPrivacy')}</a>
                  </li>
                </ul>
              </div>

              <div className="home-footer__col">
                <h3 className="home-footer__heading">{t('common.footerContact')}</h3>
                <ul className="home-footer__contact">
                  <li>
                    <span className="home-footer__contact-label">{t('common.footerHq')}</span>
                  </li>
                  <li>
                    <a href="tel:+982191000000">{t('common.footerPhone')}</a>
                  </li>
                  <li>
                    <a href="mailto:travel@soroushair.com">{t('common.footerEmail')}</a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>

          <div className="home-footer__bottom">
            <span>{t('common.footerRights', { year: new Date().getFullYear() })}</span>
            <span className="home-footer__sub">{t('common.brandSub')}</span>
          </div>
        </div>
      </footer>
    </>
  );
}
